"use client";

import {
  Button,
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Spinner,
} from "@oreme/ui";
import { ArrowRight } from "lucide-react";
import { useTranslations } from "next-intl";
import React, {
  type ReactElement,
  ChangeEvent,
  useState,
  SubmitEvent,
} from "react";
import { toast } from "sonner";
import { nominatimSearch } from "@/app/actions";
import { SitesRegionSearchResult } from "@/components";
import { Place } from "@/types";

function SitesRegionSearch(): ReactElement {
  const t = useTranslations("sites.RegionSearch");

  const [isLoading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [results, setResults] = useState<Place[]>([]);
  const [open, setOpen] = useState(false);

  const handleSubmit = async (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const results = await nominatimSearch(value);
    setLoading(false);
    setResults(results);
    console.log("results", results);

    if (results && results.length > 0) {
      setOpen(true);
    } else {
      toast(t("error.title"), {
        description: t("error.description"),
      });
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <div className="relative flex w-full items-center">
            <label htmlFor="region" className="sr-only">
              {t("placeholder")}
            </label>
            <Input
              placeholder={t("placeholder")}
              onChange={handleChange}
              value={value}
              className="h-9 pr-10"
              id="region"
            />
            <Button
              className="absolute right-2"
              type="submit"
              size="icon"
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner strokeWidth={1} />
              ) : (
                <ArrowRight strokeWidth={1} size={20} />
              )}
            </Button>
          </div>
        </PopoverTrigger>
        {results && results.length > 0 ? (
          <PopoverContent className="max-w-96 p-0 m-0">
            <SitesRegionSearchResult results={results} />
          </PopoverContent>
        ) : null}
      </Popover>
    </form>
  );
}

export { SitesRegionSearch };
